<template>
    <footer class="system-footer">
      <div class="footer-content">
        <span>Powered By:</span>
        <a href="http://unifi-me.com" target="_blank" rel="noopener noreferrer">
  <span class="company-name">VIA UNiFi INFORMATION TECHNOLOGY</span>
</a>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'SystemFooter'
  }
  </script>
  
  <style scoped>
  .system-footer {
    padding: 12px 20px;
    font-size: 14px;
    text-align: center;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    background-color: var(--bg-color);
    color: var(--font-color);
  }
  
  .footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
  
  .company-name {
    font-weight: 600;
    letter-spacing: 0.5px;
    color: #42b983;
  }
  
  .version {
    margin-left: 15px;
    font-size: 12px;
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    .system-footer {
      font-size: 12px;
      padding: 8px 10px;
    }
    .footer-content {
      flex-direction: column;
      gap: 2px;
    }
  }
  </style>